var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearchLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0001 7.9001C10.6312 7.9001 7.9001 10.6312 7.9001 14.0001C7.9001 17.369 10.6312 20.1001 14.0001 20.1001C17.369 20.1001 20.1001 17.369 20.1001 14.0001C20.1001 10.6312 17.369 7.9001 14.0001 7.9001ZM6.1001 14.0001C6.1001 9.63705 9.63705 6.1001 14.0001 6.1001C18.3631 6.1001 21.9001 9.63705 21.9001 14.0001C21.9001 18.3631 18.3631 21.9001 14.0001 21.9001C9.63705 21.9001 6.1001 18.3631 6.1001 14.0001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6638 24.9366L18.3638 19.6366L19.6366 18.3638L24.9366 23.6638L23.6638 24.9366Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchLight);
export default __webpack_public_path__ + "static/media/icon_search_light.d4c95b1a.svg";
export { ForwardRef as ReactComponent };